const LikesSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 5.23248C11.6316 4.49365 12.7242 3.66406 14.388 3.66406C17.2984 3.66406 19.25 6.39573 19.25 8.93948C19.25 14.2571 12.6298 18.3307 11 18.3307C9.37017 18.3307 2.75 14.2571 2.75 8.93948C2.75 6.39573 4.70158 3.66406 7.612 3.66406C9.27575 3.66406 10.3684 4.49365 11 5.23248Z"
      fill="#FF403D"
    />
  </svg>
);
export default LikesSvg;
